import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import PowerWashingIndustry from "@/pages/industries/PowerWashingIndustry";
export const Route = createFileRoute("/industries/power-washing")({ head: ({match}) => pageHead(match.pathname), component: () => (<PowerWashingIndustry />) });
